export default {
  email_confirm: {
    header: {
      title: 'メールアドレス確認完了',
    },
    completed: {
      section_one: '入力いただいたメールアドレスへ、ログインIDとパスワードをお送りしました。',
      section_two: 'ご確認いただき、メール内容に従ってログインしてください。',
      section_three: '30分経ってもメールが届いていない場合は、',
      section_four: 'までお知らせください。担当者より改めてご連絡します。',
    },
    expired: {
      section_one: 'ご指定のURLはすでに有効期限が過ぎています。',
      section_two: 'ご利用をご希望の場合は、',
      section_three: 'までお知らせください。担当者より改めてご連絡します。',
    },
    btn: {
      service_top: 'サービストップ',
      login: 'ログイン',
      register: '登録する',
      rating_url: 'https://asuene.com/rating',
    },
  },
}
